import _ from 'lodash';
import { computed } from 'mobx';

import { BaasicDropdownStore } from 'core/stores';

class NikoDxCodeDropdownStore extends BaasicDropdownStore {
    constructor(options, actions, initialState) {
        // Forward the (options, actions, initialState) triple to
        // BaasicDropdownStore. The previous `super()` call dropped them,
        // so `store.options` ended up at the parent's default (textField
        // "name"), and every dxCode dropdown rendered the diagnosis-code
        // description instead of develop's "code" text (e.g. "Typhoid
        // arthritis" vs "A01.04"). The fetched items array also stayed
        // empty because the configured `fetchFunc` was dropped on the floor.
        super(options, actions, initialState);

        // MobX 6 requires `override` (not `computed`) when a subclass
        // replaces a getter that the parent class already annotated.
        // BaasicDropdownStore annotates `items: computed`, so applying
        // `computed` here throws "Re-annotating fields is not allowed"
        // and aborts whatever async flow created the store — in this
        // codebase, `initializeThirdRowStores` swallows the rejection
        // and the "Show more" toggle never fires.
    }

    @computed
    get items() {
        if (!this.filterTerm && _.isObject(this.value) && !_.isArray(this.value)) {
            return [this.value];
        }

        const items = this.filteredItems.length > 0 ? this.filteredItems : this.originalItems;
        if (_.isString(this.value)) {
            return items.slice();
        }
        if (_.isArray(this.value)) {
            return [
                ...items,
                ..._.map(this.value, v => ({ ...v, hideInDropdown: true }))
            ];
        }
        if (_.isObject(this.value)) {
            return [
                ...items,
                { ...this.value, hideInDropdown: true }
            ];
        }
        return items.slice();
    }
}

export default NikoDxCodeDropdownStore;
